<template>
  <section
    class="clients section reveal-fade"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color'
    ]"
  >
    <div class="container">
      <div
        class="clients-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider'
        ]"
      >
        <ul class="list-reset">
          <li class="reveal-from-top">
            <c-image
              :src="require('@/assets/images/node_logo.svg')"
              alt="Node JS"
              :width="150"
              :height="24"
            />
          </li>
          <li class="reveal-from-bottom" data-reveal-delay="150">
            <c-image
              :src="require('@/assets/images/firebase_logo.svg')"
              alt="Firebase"
              :width="150"
              :height="24"
            />
          </li>
          <li class="reveal-from-top" data-reveal-delay="300">
            <c-image
              :src="require('@/assets/images/api_logo.svg')"
              alt="API Integrations"
              :width="125"
              :height="20"
            />
          </li>
          <li class="reveal-from-bottom" data-reveal-delay="450">
            <c-image
              :src="require('@/assets/images/airtable_logo.svg')"
              alt="Replace Airtable with a custom SaaS"
              :width="150"
              :height="31"
            />
          </li>
          <li class="reveal-from-top" data-reveal-delay="600">
            <c-image
              :src="require('@/assets/images/wordpress_logo.svg')"
              alt="Replace Wordpress with a custom SaaS"
              :width="160"
              :height="30"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from "@/utils/SectionProps.js";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CClients",
  components: {
    CImage
  },
  mixins: [SectionProps]
};
</script>
